import { evaluateInAppRpc } from '../../../__generated__/chirp/com/hubspot/purchase/motions/rpc/PurchaseMotionsEvaluationService';
import { rpcClient } from '../../rpcClient';
import { logRavenException } from '../../errorUtils';
export const fetchPurchaseMotions = ({
  productApiNames,
  purchaseMotionLocation
}) => {
  const locations = [purchaseMotionLocation];
  const purchaseMotionByProductApiName = {};
  for (const productApiName of productApiNames) {
    purchaseMotionByProductApiName[productApiName] = 'TALK_TO_SALES';
  }
  let promiseError = undefined;
  return rpcClient.call(evaluateInAppRpc, {
    request: {
      productApiNames,
      locations
    }
  }).then(response => {
    for (const [productApiName, purchaseMotionsByPriority] of Object.entries(response.purchaseMotionsMapping.productsByLocationString[purchaseMotionLocation].purchaseMotionsByProductApiName)) {
      purchaseMotionByProductApiName[productApiName] = purchaseMotionsByPriority.purchaseMotions[0];
    }
  }, error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: error.message,
      additionalDetails: {
        productApiNames,
        locations
      }
    });
  }).catch(error => {
    promiseError = error;
    logRavenException({
      error,
      customMessage: 'fetchPurchaseMotions: Promise successfully resolved but the catch block was triggered',
      additionalDetails: {
        productApiNames,
        locations
      }
    });
  }).then(() => {
    if (promiseError) {
      console.error(promiseError);
    }
    return purchaseMotionByProductApiName;
  });
};